import React, { useState, useEffect } from "react";
import axios from "axios"; // for making API calls
import { Link } from "react-router-dom"; // for routing
import swal from "sweetalert";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPencil, faPlus, faTrash } from "@fortawesome/free-solid-svg-icons";

const ContentsPage = ({ bannerType, pageType }) => {
  const [bannersList, setBannersList] = useState([]);
  const [addPage, setAddPage] = useState("");
  const [deletePage, setDeletePage] = useState("");
  const [page, setPage] = useState(0); // Assuming page is being passed as prop or managed
  const [roles, setRoles] = useState({});

  useEffect(() => {
    // Fetch the banners list
    axios
      .get(`/website/contents/${pageType}`)
      .then((response) => {
        setBannersList(response.data.banners);
      })
      .catch((error) => {
        console.error("Error fetching banners:", error);
      });

    // Fetch roles and permissions (assuming an API endpoint exists for roles)
    axios
      .get("/roles/contents")
      .then((response) => {
        setRoles(response.data);
      })
      .catch((error) => {
        console.error("Error fetching roles:", error);
      });

    // Construct URLs
    setAddPage(`/Website/Contents/add/${pageType}`);
    setDeletePage(`/Website/Contents/delete/${pageType}`);
  }, [pageType]);

  const handleDelete = (postId) => {
    swal({
      title: "Are you sure?",
      text: "You will not be able to recover this Record!",
      icon: "warning",
      buttons: ["No, cancel!", "Yes, delete it!"],
    }).then((isConfirm) => {
      if (isConfirm) {
        axios
          .delete(`${deletePage}/${postId}`)
          .then(() => {
            setBannersList(bannersList.filter((post) => post.id !== postId));
            swal("Deleted!", "The record has been deleted.", "success");
          })
          .catch((error) => {
            swal("Error!", "There was an error deleting the record.", "error");
          });
      } else {
        swal("Cancelled", "Your record is safe.", "error");
      }
    });
  };

  const renderBannerRows = () => {
    return bannersList.map((post, index) => {
      const i = page + index + 1;
      return (
        <tr key={post.id}>
          <td style={{ textAlign: "center", verticalAlign: "middle" }}>{i}</td>
          <td>{post.title}</td>
          {bannerType === 0 && (
            <>
              <td>{post.text1}</td>
              <td>{post.text2}</td>
              <td>{post.text3}</td>
            </>
          )}
          {![2, 3, 4, 6].includes(bannerType) && (
            <>
              <td>{post.btn_text}</td>
              <td>{post.btn_link}</td>
            </>
          )}
          {bannerType === 3 && <td>{post.btn_link}</td>}
          {bannerType === 4 && (
            <>
              <td>{post.text1}</td>
              <td>{post.btn_text}</td>
            </>
          )}
          {bannerType === 6 && (
            <>
              <td>{post.text1}</td>
              <td>{post.text2}</td>
            </>
          )}
          {![0, 3].includes(bannerType) && <td>{post.description}</td>}
          {bannerType === 4 && <td>{post.referral_text}</td>}
          <td>{post.isactive ? "Active" : "Inactive"}</td>
          <td>
            {roles["contents"]?.edit && (
              <Link
                to={`${addPage}/${post.id}`}
                className="btn btn-warning btn-xs"
              >
                <FontAwesomeIcon icon={faPencil} />
              </Link>
            )}
          </td>
          <td>
            {roles["contents"]?.delete && ![4, 5, 6].includes(bannerType) && (
              <button
                className="btn btn-danger btn-xs"
                onClick={() => handleDelete(post.id)}
              >
                <FontAwesomeIcon icon={faTrash} />
              </button>
            )}
          </td>
        </tr>
      );
    });
  };

  return (
    <div className="panel panel-default with-rounded-corner with-shadow">
      <div id="content" className="mt-5">
        <div className="panel-heading border-0">
          <h4 className="panel-title pull-left">Manage Contents</h4>
          {roles["contents"]?.add && ![4, 5, 6].includes(bannerType) && (
            <button
              className="btn btn-default btn-sm pull-right"
              onClick={() => (window.location.href = addPage)}
            >
              <FontAwesomeIcon icon={faPlus} /> Add Contents
            </button>
          )}
        </div>

        {bannersList.length ? (
          <div className="table-responsive">
            <table className="table m-b-0">
              <thead>
                <tr>
                  <th style={{ textAlign: "center" }}>#</th>
                  <th>Title</th>
                  {bannerType === 0 && (
                    <>
                      <th>Text1</th>
                      <th>Text2</th>
                      <th>Text3</th>
                    </>
                  )}
                  {![2, 3, 4, 6].includes(bannerType) && (
                    <>
                      <th>Button Text</th>
                      <th>Button Link</th>
                    </>
                  )}
                  {bannerType === 3 && <th>Link</th>}
                  {bannerType === 4 && (
                    <>
                      <th>Small Text</th>
                      <th>Button Text</th>
                    </>
                  )}
                  {bannerType === 6 && (
                    <>
                      <th>Code</th>
                      <th>Code Text</th>
                    </>
                  )}
                  {![0, 3].includes(bannerType) && <th>Description</th>}
                  {bannerType === 4 && <th>Referral Text</th>}
                  <th>Status</th>
                  <th style={{ width: "1%" }} colSpan="2">
                    Action
                  </th>
                </tr>
              </thead>
              <tbody>{renderBannerRows()}</tbody>
            </table>
          </div>
        ) : (
          <p>No records found</p>
        )}
      </div>

      <a href="#" data-click="scroll-top" className="btn-scroll-top fade">
        <i className="ti-arrow-up"></i>
      </a>
    </div>
  );
};

export default ContentsPage;
